import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "./store";
import metadata from "./store/metadata";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ui from "./store/ui";
import { Helmet } from "react-helmet";

function Metadata() {
  const dispatch = useDispatch();
  const { customerName, orderRef, title, worldOrder } = useSelector(
    (state: RootState) => state.document.metadata
  );
  const expanded = useSelector(
    (state: RootState) => state.uiState.metadataExpanded
  );

  const [orderError, setOrderError] = useState<string | null>(null);
  const [orderBlurred, setOrderBlurred] = useState(false);
  useEffect(() => {
    if (orderBlurred) {
      const match = worldOrder.match(/^[0-9]{9}[0-9]?$/);
      if (!!worldOrder && !match) {
        setOrderError("Order number not valid!");
      } else {
        setOrderError("");
      }
    }
  }, [worldOrder, orderBlurred]);

  return (
    <>
      <Helmet>
        <title>Fibonacci Configurator{title && " - " + title}</title>
      </Helmet>
      <Accordion
        expanded={expanded}
        onChange={() => dispatch(ui.actions.metadataExpandedToggled())}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant={"button"}>
            {title || "Untitled Project"}
          </Typography>
          <Box
            display="flex"
            alignItems="center"
            width="80%"
            ml="auto"
            justifyContent="space-around"
          >
            <Typography color="textSecondary" variant="caption">
              {customerName}
            </Typography>
            <Typography color="textSecondary" variant="caption">
              {orderRef}
            </Typography>
            <Typography color="textSecondary" variant="caption">
              {worldOrder}
            </Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                size="small"
                label="Project name"
                fullWidth
                value={title}
                onChange={(ev) =>
                  dispatch(metadata.actions.titleUpdated(ev.target.value))
                }
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                size="small"
                label="Customer name"
                fullWidth
                value={customerName}
                onChange={(ev) =>
                  dispatch(
                    metadata.actions.customerNameUpdated(ev.target.value)
                  )
                }
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                size="small"
                label="Your order reference"
                fullWidth
                value={orderRef}
                onChange={(ev) =>
                  dispatch(metadata.actions.orderRefUpdated(ev.target.value))
                }
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                size="small"
                label="Basalte World order number"
                fullWidth
                value={worldOrder}
                onChange={(ev) => {
                  dispatch(metadata.actions.worldOrderUpdated(ev.target.value));
                }}
                error={!!orderError}
                helperText={orderError ?? undefined}
                variant="outlined"
                onBlur={() => setOrderBlurred(true)}
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </>
  );
}

export default Metadata;
